import React from 'react';
import styled from 'styled-components';
import { APP_DOMAIN, APP_ENV } from 'appenv';

const RootContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: white;
  z-index: 99999;
  padding: 8px;
  opacity: 0.6;
  pointer-events: none;
`;

const EnvIndicator = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  return (
    <RootContainer id="env-indicator-container">
      <span className="env-indicator-text" id="current-env">
        {`Environment: ${APP_ENV}`}
      </span>
      <br />
      <span className="env-indicator-text" id="current-domain">
        {`App Domain: ${APP_DOMAIN}`}
      </span>
    </RootContainer>
  );
};

export default EnvIndicator;
